import { observer } from "mobx-react-lite";
import type { RefObject } from "react";

import { SCROLL_REVIEW_LOGS_DRAWER_TO_TOP_EVENT } from "./ReviewLogsDrawerControls/constants";
import { useStructuredSearchActiveEffect } from "./hooks/useStructuredSearchActiveEffect";

import StructuredSearchbar from "@/components/StructuredSearch";
import type { StructuredSearchSchema } from "@/components/StructuredSearch/config/structured-search-schema";

export interface SidebarStructuredSearchControlsProps {
  inputRef: RefObject<HTMLInputElement | null>;
  config?: StructuredSearchSchema;
  onExploreInTable?: () => void;
  onExploreInTablePreload?: () => void;
  onFilterRemove?: () => void;
  onRefresh?: () => void;
  onSearchActiveChange?: (isActive: boolean) => void;
  isRefreshing?: boolean;
  hasNewData?: boolean;
}

const defaultHandleFilterRemove = () => {
  window.dispatchEvent(new Event(SCROLL_REVIEW_LOGS_DRAWER_TO_TOP_EVENT));
};

export const SidebarStructuredSearchControls = observer(
  ({
    inputRef,
    config,
    onExploreInTable,
    onExploreInTablePreload,
    onFilterRemove = defaultHandleFilterRemove,
    onRefresh,
    onSearchActiveChange,
    isRefreshing,
    hasNewData,
  }: SidebarStructuredSearchControlsProps) => {
    useStructuredSearchActiveEffect(onSearchActiveChange);

    return (
      <div className="w-full">
        <div className="flex items-center justify-between gap-2">
          <div className="min-w-0 flex-1">
            <StructuredSearchbar
              config={config}
              variant="compact"
              showHeader={false}
              cancelBuilderOnBlur
              onExploreInTable={onExploreInTable}
              onExploreInTablePreload={onExploreInTablePreload}
              onFilterRemove={onFilterRemove}
              onRefresh={onRefresh}
              isRefreshing={isRefreshing}
              hasNewData={hasNewData}
              rootInputRef={inputRef}
              className="w-full"
            />
          </div>
        </div>
      </div>
    );
  },
);
